import { UserContactsBlockResponse } from "../../proto/UserContactsBlock_pb";
import store from "../../store";
import { addUserBlocked } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";

export default class HandleUserContactsBlockResponse extends BaseHandler<UserContactsBlockResponse> {
  handle() {
    const userContactsBlockResponse = this.response.toObject();
    store.dispatch(addUserBlocked([userContactsBlockResponse.userId]));
  }
}
